/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentResponse as ModelsCustomerCustomerOnlinePaymentResponse } from '../../models/Models/Customer/customer-online-payment-response';

export interface V4CustomersMeOnlinePaymentsIdGet$Json$Params {
  id: string;
}

export function v4CustomersMeOnlinePaymentsIdGet$Json(http: HttpClient, rootUrl: string, params: V4CustomersMeOnlinePaymentsIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOnlinePaymentsIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>;
    })
  );
}

v4CustomersMeOnlinePaymentsIdGet$Json.PATH = '/v4/customers/me/online-payments/{id}';
